


























































import { defineComponent, reactive, computed } from '@vue/composition-api';
import { usePageBase, useComponentBase } from '../../base';
import { Utils } from '../../helpers/utils';
import { isNullOrTodo } from '../../helpers/filters';
import { getStore } from '../../store';
import { useRouter } from '../../router';

const componentName = 'AppVersionsList';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const store = getStore(), { router, route } = useRouter();
        const pageBase = usePageBase();
        const componentBase = useComponentBase();

        const state = reactive({
            loaded: false,
            appVersions: null
        });

        const onCreated = () => {
            componentBase.setLoading(true);

            state.appVersions = store.state.appVersions;
            pageBase.setNavigation((nav) => {
                nav.push({ title: 'Apps', routerTo: { name: 'apps' } });
                nav.push({ title: appNameForPagePath.value });
            });
            state.loaded = true;
            componentBase.setLoading(false);
        }

        const appId = computed(() => route.value.params.appId);

        const appNameForPagePath = computed(() => {
                if (!state.appVersions || !Array.isArray(state.appVersions) || state.appVersions.length == 0) {
                    return '';
                }
                return `${state.appVersions[0].name} ${state.appVersions[0].platform}`;
            }
        );

        const appName = computed(() => {
                if (!state.appVersions || !Array.isArray(state.appVersions) || state.appVersions.length == 0) {
                    return '';
                }
                return state.appVersions[0].name;
            }
        );

        const appShortName = computed(() => {
                if (!state.appVersions || !Array.isArray(state.appVersions) || state.appVersions.length == 0) {
                    return '';
                }
                return state.appVersions[0].shortName;
            }
        );

        const appPlatform = computed(() => {
                if (!state.appVersions || !Array.isArray(state.appVersions) || state.appVersions.length == 0) {
                    return '';
                }
                return state.appVersions[0].platform;
            }
        );

        const appVersionsForList = computed(() => {
            var listElement = []

            if (state.appVersions == null) {
                return;
            }

            state.appVersions.forEach(v => {

                var langElements = [];

                v.languages.forEach(l => {
                    langElements.push({
                        code: l,
                        name : Utils.getLanguageName(l),
                        done : (v.keys == null) ? 0 : v.keys.filter(k => !isNullOrTodo(k.texts[l])).length
                    })
                });

                listElement.push(
                    { id: v.id,
                    version: v.version,
                    build: v.build,
                    keysNumber: (v.keys == null) ? 0 : v.keys.length,
                    languages : langElements
                    })
            });

            return listElement;
        });

        const percentage = (done: number, total: number) => {
            return (total == 0) ? 0 : Math.floor(((done / total) * 100));
        }

        const totalPercentageCompletion = (version : any) => {
            var totalDone = 0;
            version.languages.forEach(l => {
                totalDone = totalDone + l.done
            });

            var res = (totalDone / (version.keysNumber * version.languages.length)) * 100;

            return res ? Math.floor(res) : 0;
        }

        const completionColor = (perc: number) => {
            return Utils.getCompletionColor(perc);
        }

        const platformIconClass = (platform: string) => {
            return Utils.iconPlatformClass('icon', platform);
        }

        const filterLanguages = (languages: { code: string }[]) => {
            return languages.filter(x => pageBase.hasTranslatorLanguage(x.code));
        }

        onCreated();

        return {
            state,
            appNameForPagePath,
            appName,
            appShortName,
            appPlatform,
            appVersionsForList,
            percentage,
            totalPercentageCompletion,
            completionColor,
            platformIconClass,
            filterLanguages,
            isUserAdmin: pageBase.isUserAdmin,
            appId
        }
    }
})

